import { addMinutes, differenceInMinutes } from "date-fns";
import React from "react";
import { MINUTE_MILLIS } from "@fidget/common/utils/timeUtils";
import { L10n } from "../../i18n";

// TODO: move it to paymentStore(?)

interface Props {
  startTimestamp: number;
  callMaxDuration: number;
}

interface State {
  differenceMinutes?: number;
}

export class CallTimeLeftTimer extends React.Component<Props, State> {
  private timer?: number;
  endLimitTime: Date;

  constructor(props: Props) {
    super(props);
    this.state = { differenceMinutes: undefined };
    this.endLimitTime = addMinutes(props.startTimestamp, this.props.callMaxDuration + 1);
  }

  componentDidMount() {
    const callMaxDuration = this.props.callMaxDuration;
    if (callMaxDuration) {
      this.timer = window.setTimeout(this.startInterval, MINUTE_MILLIS * (callMaxDuration - 3));
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  private getDifferenceMinutes() {
    return differenceInMinutes(this.endLimitTime, Date.now());
  }

  startInterval = () => {
    this.tick();
    this.timer = window.setInterval(this.tick, MINUTE_MILLIS);
  };

  private tick = () => {
    this.setState({ differenceMinutes: this.getDifferenceMinutes() });
  };

  render() {
    return this.state.differenceMinutes ? (
      <L10n id={"header.call.timeLeft"} values={{ count: this.state.differenceMinutes }} />
    ) : (
      <></>
    );
  }
}
